export default __webpack_public_path__ + "static/media/arrow-search.50811764.svg";